export default __webpack_public_path__ + "static/media/frame.824f91fe.svg";